export const pointGroups = [
  'C1',
  'Cs',
  'Ci',
  'C*v',
  'D*h',
  'C2',
  'C3',
  'C2h',
  'C3h',
  'C2v',
  'C3v',
  'C4v',
  'C5v',
  'D2',
  'D3',
  'D2h',
  'D3h',
  'D4h',
  'D5h',
  'D6h',
  'D7h',
  'D8h',
  'D2d',
  'D3d',
  'D4d',
  'D5d',
  'S4',
  'Td',
  'Th',
  'Oh',
  'Ih',
];
